import { getCharityTicketsForRace } from '../ticket';

/**
 * Returns boolean whether any races charity tickets available.
 */
export default (races = []) =>
  races.filter((race) => getCharityTicketsForRace(race).length > 0).length > 0;
